import app from 'flarum/forum/app';
import { currentUrlKey } from './paginationUtils';
const READMORE_MAX_HEIGHT = 240;
let readMoreObserver = null;
let routeTimer = null;
let urlWatchTimer = null;
let lastUrl = '';
function readMoreEnabled() {
  return app.forum.attribute('magicread_enable_readmore') !== false;
}
function isUserPage() {
  var _app$current;
  const routeName = (_app$current = app.current) == null ? void 0 : _app$current.routeName;
  if (routeName && routeName.startsWith('user')) return true;
  const path = typeof location !== 'undefined' && location.pathname || '';
  if (path.startsWith('/u/')) return true;
  return !!document.querySelector('.UserPage');
}
function injectReadMoreCssOnce() {
  if (document.getElementById('MagicRead-ReadMoreStyle')) return;
  const style = document.createElement('style');
  style.id = 'MagicRead-ReadMoreStyle';
  style.textContent = "\n    .MagicRead-ReadMoreBody.MagicRead-ReadMoreBody--collapsed{\n      max-height:".concat(READMORE_MAX_HEIGHT, "px;\n      overflow:hidden;\n      position:relative;\n    }\n    .MagicRead-ReadMoreBody.MagicRead-ReadMoreBody--collapsed::after{\n      content:'';\n      position:absolute;\n      left:0; right:0; bottom:0;\n      height:64px;\n      pointer-events:none;\n      background: linear-gradient(to bottom, rgba(0,0,0,0), var(--body-bg));\n    }\n    .MagicRead-ReadMoreBtn{\n      display:flex;\n      align-items:center;\n      justify-content:center;\n      margin:10px auto 0;\n      border:0;\n      border-radius:999px;\n      padding:6px 10px;\n      cursor:pointer;\n      font-size:12px;\n      font-weight:700;\n      line-height:1;\n      font-family:inherit;\n      background: var(--control-bg);\n      color: var(--text-color) !important;\n      opacity:.95;\n      transition: opacity .15s ease, transform .15s ease;\n    }\n    .MagicRead-ReadMoreBtn,\n    .MagicRead-ReadMoreBtn:visited,\n    .MagicRead-ReadMoreBtn:hover,\n    .MagicRead-ReadMoreBtn:active,\n    .MagicRead-ReadMoreBtn:focus{\n      color: var(--text-color) !important;\n    }\n    .MagicRead-ReadMoreBtn *{\n      color: inherit !important;\n    }\n    .MagicRead-ReadMoreBtn:hover{\n      opacity:1;\n      transform:translateY(-1px);\n    }\n    .MagicRead-ReadMoreBtn:active{\n      transform:translateY(0);\n    }\n  ");
  document.head.appendChild(style);
}
function collapseBodyIfNeeded(body) {
  var _body$parentElement;
  if (body.dataset.magicreadProcessed === '1') return;
  body.dataset.magicreadProcessed = '1';
  if (body.dataset.magicreadExpanded === '1') return;
  const fullHeight = body.scrollHeight;
  if (fullHeight <= READMORE_MAX_HEIGHT + 40) return;
  body.classList.add('MagicRead-ReadMoreBody', 'MagicRead-ReadMoreBody--collapsed');
  if (!body.dataset.magicreadId) {
    body.dataset.magicreadId = String(Math.random()).slice(2);
  }
  const existing = (_body$parentElement = body.parentElement) == null ? void 0 : _body$parentElement.querySelector(".MagicRead-ReadMoreBtn[data-for=\"".concat(body.dataset.magicreadId, "\"]"));
  if (existing) return;
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'MagicRead-ReadMoreBtn';
  btn.dataset.for = body.dataset.magicreadId;
  btn.textContent = String(app.translator.trans('forumaker-magicread.forum.read_more'));
  btn.addEventListener('click', () => {
    body.classList.remove('MagicRead-ReadMoreBody--collapsed');
    body.dataset.magicreadExpanded = '1';
    btn.remove();
  });
  body.insertAdjacentElement('afterend', btn);
}
function applyReadMoreOnce() {
  if (!readMoreEnabled() || !isUserPage()) return;
  injectReadMoreCssOnce();
  const bodies = Array.from(document.querySelectorAll('.UserPage .CommentPost .Post-body'));
  bodies.forEach(collapseBodyIfNeeded);
}
function resetReadMoreProcessed() {
  const bodies = Array.from(document.querySelectorAll('.UserPage .CommentPost .Post-body'));
  bodies.forEach(b => {
    var _b$parentElement;
    if (b.dataset.magicreadExpanded === '1') return;
    b.dataset.magicreadProcessed = '0';
    b.classList.remove('MagicRead-ReadMoreBody', 'MagicRead-ReadMoreBody--collapsed');
    const btn = (_b$parentElement = b.parentElement) == null ? void 0 : _b$parentElement.querySelector(".MagicRead-ReadMoreBtn[data-for=\"".concat(b.dataset.magicreadId || '', "\"]"));
    if (btn) btn.remove();
  });
}
function bindReadMoreObserver() {
  var _ref;
  if (readMoreObserver) return;
  if (!readMoreEnabled() || !isUserPage()) return;
  readMoreObserver = new MutationObserver(() => {
    applyReadMoreOnce();
  });
  const root = (_ref = document.querySelector('.UserPage')) != null ? _ref : document.body;
  readMoreObserver.observe(root, {
    childList: true,
    subtree: true
  });
  applyReadMoreOnce();
}
function unbindReadMoreObserver() {
  if (!readMoreObserver) return;
  readMoreObserver.disconnect();
  readMoreObserver = null;
}
function rerenderAfterRouteChange() {
  handleReadMoreRouteChange();
  setTimeout(handleReadMoreRouteChange, 80);
  setTimeout(handleReadMoreRouteChange, 180);
  setTimeout(handleReadMoreRouteChange, 320);
}
export function applyReadMoreToPost(root) {
  if (!readMoreEnabled()) return;
  const body = root.querySelector('.Post-body');
  if (!body) return;
  const isOnUserPage = !!root.closest('.UserPage') || !!document.querySelector('.UserPage') || (typeof location !== 'undefined' && location.pathname || '').startsWith('/u/');
  if (!isOnUserPage) return;
  if (body.dataset.magicreadExpanded === '1') return;
  body.dataset.magicreadProcessed = '0';
  collapseBodyIfNeeded(body);
}
export function handleReadMoreRouteChange() {
  if (routeTimer) window.clearTimeout(routeTimer);
  routeTimer = window.setTimeout(() => {
    if (readMoreEnabled() && isUserPage()) {
      injectReadMoreCssOnce();
      bindReadMoreObserver();
      resetReadMoreProcessed();
      applyReadMoreOnce();
      setTimeout(() => {
        resetReadMoreProcessed();
        applyReadMoreOnce();
      }, 120);
      setTimeout(() => {
        resetReadMoreProcessed();
        applyReadMoreOnce();
      }, 260);
    } else {
      unbindReadMoreObserver();
    }
  }, 0);
}
export function startReadMoreUrlWatch() {
  if (urlWatchTimer) return;
  lastUrl = currentUrlKey();
  urlWatchTimer = window.setInterval(() => {
    const now = currentUrlKey();
    if (now !== lastUrl) {
      lastUrl = now;
      rerenderAfterRouteChange();
    }
  }, 120);
}
export function stopReadMoreUrlWatch() {
  if (urlWatchTimer) {
    window.clearInterval(urlWatchTimer);
    urlWatchTimer = null;
  }
  if (routeTimer) {
    window.clearTimeout(routeTimer);
    routeTimer = null;
  }
  unbindReadMoreObserver();
}
flarum.reg.add('forumaker-magicread', 'forum/components/readMore', { applyReadMoreToPost: applyReadMoreToPost,handleReadMoreRouteChange: handleReadMoreRouteChange,startReadMoreUrlWatch: startReadMoreUrlWatch,stopReadMoreUrlWatch: stopReadMoreUrlWatch, });